const Upload = ({ name = "file", update }) => {
  return (
    <label htmlFor={name}>
      <i className="fa fa-upload fa-3x" />
      <input
        type="file"
        id={name}
        name={name}
        style={{ display: "none" }}
        onChange={(e) => update(name, e.target.files[0])}
      />
    </label>
  );
};

export default Upload;
